class BottomSheet {
  #rootElement: HTMLElement | null;

  constructor() {
    this.#rootElement = null;
  }

  handleSheetHide(callback?: () => void) {
    if (this.#rootElement === null) {
      return;
    }

    const root = this.#rootElement;

    const hide = () => {
      callback?.();

      if (root.isConnected) {
        root.remove();
      }

      this.#rootElement = null;
    };

    root.classList.add("kdl-bottom-sheet--hiding");
    root.addEventListener("animationend", hide);
  }

  handleSheetShow(contentElement: HTMLElement) {
    if (this.#rootElement !== null) {
      return;
    }

    this.#rootElement = document.createElement("div");
    this.#rootElement.classList.add("kdl-bottom-sheet");
    this.#rootElement.setAttribute("tabindex", "-1");
    this.#rootElement.innerHTML = `
      <div class="kdl-bottom-sheet__wrapper"></div>
    `;

    const wrapper = this.#rootElement.querySelector<HTMLElement>(".kdl-bottom-sheet__wrapper");
    if (wrapper === null) {
      this.#rootElement.remove();
      this.#rootElement = null;

      return;
    }

    wrapper.append(contentElement);
    document.body.append(this.#rootElement);
  }
}

export { BottomSheet };
